export const HANDLE_GRID_CHANGE = "HANDLE_GRID_CHANGE";
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
